import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

interface Passenger {
  adult: number;
  children: number;
  infant: number;
}

@Component({
  selector: 'tours-and-experiences-passenger-count',
  templateUrl: './tours-and-experiences-passenger-count.component.html',
  styleUrls: ['./tours-and-experiences-passenger-count.component.scss'],
})
export class ToursAndExperiencesPassengerCountComponent implements OnInit {
  @Input() travellerCount: any;

  constructor(
    private modalController: ModalController,
    private translate: TranslateService
  ) {}

  ngOnInit() {}

  add(type) {
    switch (type) {
      case 'adult':
        this.travellerCount.adult = this.travellerCount.adult + 1;
        break;
      case 'children':
        this.travellerCount.children = this.travellerCount.children + 1;
        break;
      case 'infant':
        this.travellerCount.infant = this.travellerCount.infant + 1;
        break;
      default:
        return;
    }
  }

  subtract(type) {
    switch (type) {
      case 'adult':
        this.travellerCount.adult = this.travellerCount.adult - 2;
        if (this.travellerCount.adult < 1) {
          this.travellerCount.adult = 1;
        }
        break;
      case 'children':
        this.travellerCount.children = this.travellerCount.children - 1;
        if (this.travellerCount.children < 0) {
          this.travellerCount.children = 0;
        }
        break;
      case 'infant':
        this.travellerCount.infant = this.travellerCount.infant - 1;
        if (this.travellerCount.infant < 0) {
          this.travellerCount.infant = 0;
        }
        break;
      default:
        return;
    }
  }

  closeModal() {
    this.modalController.dismiss(this.travellerCount);
  }
}
